import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Typography,
} from "@mui/material";
import { useDeleteProject } from "../../../api/use-project.js";
import { useNavigate } from "react-router-dom";
import { ToastContext } from "../../../contexts/toast-context.jsx";

export const DeleteProject = ({ open, project, onClose }) => {
  const { t } = useTranslation(["project", "common"]);
  const navigate = useNavigate();
  const { showSuccess } = useContext(ToastContext);

  const [{ loading, error }, execute] = useDeleteProject(project?.id);

  const handleDelete = async () => {
    await execute();
    navigate("/projects");
    showSuccess(t("successfulAction"));
  };

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>{t("deleteProject")}</DialogTitle>
      <DialogContent>
        <Typography variant="body">{t("deleteProjectConfirm", {name: project?.name})}</Typography>
        {error && (
          <FormHelperText error>
            {t("genericError", { action: t("deleteProject") })}
          </FormHelperText>
        )}
        {loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={30} sx={{ mt: 3 }} />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} disabled={loading}>
          {t("cancel")}
        </Button>
        <Button onClick={handleDelete} disabled={loading} autoFocus>
          {t("delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
